import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import AboutMinimal from './AboutMinimal';
import ProcessMinimal from './ProcessMinimal';

const AboutPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-black" data-testid="about-page">
      <Helmet>
        <title>About Aryan Shivhare | Berlin-Based Digital Marketer & Content Creator</title>
        <meta
          name="description"
          content="Learn about Aryan Shivhare — a Berlin-based, AI-driven digital marketer and content creator. €200K+ in paid social managed, 50K+ followers grown, 300% average client ROI."
        />
        <meta name="keywords" content="Aryan Shivhare, about, Berlin digital marketer, performance marketing, content creator" />
        <link rel="canonical" href="https://aryanshivhare.com/about" />
        <meta property="og:title" content="About Aryan Shivhare | Berlin-Based Digital Marketer" />
        <meta property="og:description" content="Berlin-based, AI-driven digital marketer and content creator. €200K+ paid social managed, 50K+ followers grown, 300% average ROI." />
        <meta property="og:type" content="profile" />
        <meta property="og:url" content="https://aryanshivhare.com/about" />
      </Helmet>

      <div className="pt-16">
        <AboutMinimal />
        <ProcessMinimal />
      </div>
    </div>
  );
};

export default AboutPage;
